var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"file xls\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"file xls\"_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"file xls\"_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13758 1C2.40474 1 1 2.40062 1 4.12917V11.4361C1 13.1642 2.39408 14.5652 4.13758 14.5652H21.8624C23.5953 14.5652 25 13.1646 25 11.4361V4.12917C25 2.40098 23.6059 1 21.8624 1H4.13758ZM4.12476 2.04348C2.9753 2.04348 2.04348 2.98279 2.04348 4.1221V11.4431C2.04348 12.5911 2.98505 13.5217 4.12476 13.5217H21.8752C23.0247 13.5217 23.9565 12.5824 23.9565 11.4431V4.1221C23.9565 2.97411 23.0149 2.04348 21.8752 2.04348H4.12476Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 43535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PDF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4453 11V4.21973H22.0005V5.37524H18.7632V7.12283H21.4562V8.19239H18.7632V11H17.4453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6094 11V4.21973H13.0732C13.6271 4.21973 14.1109 4.30886 14.5247 4.48712C14.9449 4.66538 15.2951 4.9073 15.5752 5.21289C15.8553 5.51848 16.0654 5.87819 16.2055 6.29201C16.3456 6.69946 16.4156 7.13556 16.4156 7.60031C16.4156 8.116 16.336 8.58393 16.1768 9.00412C16.024 9.41794 15.8012 9.77446 15.5084 10.0737C15.2155 10.3665 14.8622 10.5957 14.4483 10.7613C14.0409 10.9204 13.5825 11 13.0732 11H10.6094ZM15.0882 7.60031C15.0882 7.27562 15.0436 6.9764 14.9545 6.70264C14.8653 6.42889 14.7348 6.19333 14.5629 5.99597C14.391 5.79861 14.1778 5.64581 13.9231 5.53758C13.6748 5.42935 13.3915 5.37524 13.0732 5.37524H11.9272V9.84449H13.0732C13.3979 9.84449 13.6844 9.78719 13.9327 9.67259C14.1873 9.558 14.3974 9.40202 14.5629 9.20466C14.7348 9.00093 14.8653 8.76219 14.9545 8.48843C15.0436 8.21468 15.0882 7.91864 15.0882 7.60031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.65918 11V4.21973H7.53363C7.84559 4.21973 8.13208 4.28657 8.39311 4.42027C8.6605 4.5476 8.88969 4.71949 9.08068 4.93595C9.27168 5.14605 9.42129 5.38797 9.52952 5.66173C9.63775 5.92912 9.69186 6.19969 9.69186 6.47345C9.69186 6.75994 9.64093 7.04007 9.53907 7.31382C9.4372 7.58121 9.29396 7.81996 9.10933 8.03005C8.9247 8.24014 8.70188 8.40885 8.44085 8.53618C8.17983 8.66351 7.89334 8.72718 7.58138 8.72718H5.97704V11H4.65918ZM5.97704 7.57166H7.50498C7.74691 7.57166 7.94745 7.47298 8.10661 7.27562C8.27214 7.07826 8.35491 6.81087 8.35491 6.47345C8.35491 6.30156 8.32944 6.14876 8.27851 6.01507C8.22758 5.875 8.16073 5.75723 8.07797 5.66173C7.9952 5.56623 7.89652 5.4962 7.78193 5.45164C7.6737 5.4007 7.56228 5.37524 7.44769 5.37524H5.97704V7.57166Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8752 13.5217C23.0247 13.5217 23.9565 12.5824 23.9565 11.4431V4.1221C23.9565 2.97411 23.0149 2.04348 21.8752 2.04348H4.12476C2.9753 2.04348 2.04348 2.98279 2.04348 4.1221V11.4431C2.04348 12.5911 2.98505 13.5217 4.12476 13.5217H21.8752ZM3.23439 14.4348C3.51611 14.5185 3.81487 14.564 4.12476 14.5652C4.12903 14.5652 4.13331 14.5652 4.13758 14.5652H21.8624C21.8667 14.5652 21.871 14.5652 21.8752 14.5652C23.5998 14.5583 24.9962 13.1641 25 11.4431C25 11.4408 25 11.4384 25 11.4361V4.12917C25 4.12681 25 4.12446 25 4.1221C24.9962 2.4014 23.6104 1.00686 21.8752 1.00003C21.871 1.00001 21.8667 1 21.8624 1H4.13758C4.13331 1 4.12903 1.00001 4.12476 1.00003C3.81674 1.00125 3.51919 1.04674 3.23817 1.13043C1.9458 1.51535 1.00314 2.70846 1.00001 4.1221C1 4.12446 1 4.12681 1 4.12917V11.4361C1 11.4384 1 11.4408 1.00001 11.4431C1.00311 12.8565 1.93869 14.0498 3.23439 14.4348Z",
    fill: "#21231E",
    stroke: "black",
    strokeWidth: 0.3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.e2759128b8229fefe93868ba45b5c4a9.svg";
export { ForwardRef as ReactComponent };